export const backofficeConfig = {
  legalName: "ALYPLUS TECNOLOGIA E SOLUÇÕES DE PAGAMENTO LTDA",
  legalDocument: "55117132000190",
  contactEmail: "contato@alyplus.com.br",
  website: "alyplus.com.br",
  address: {
    line1: "Av. Marquês de São Vicente, 405, 14 Andar",
    line2: "Barra Funda",
    city: "São Paulo",
    state: "SP",
    postalCode: "01139001",
    country: "BR"
  }
};

export const backofficeBcertoConfig = {
  legalName: "Banco Certo Certo Pay Meios de Pagamentos LTDA",
  legalDocument: "55419495000180",
  contactEmail: "",
  website: "",
  address: {
    line1: "Av. Paulista, 2439 - Bela Vista,",
    line2: "São Paulo - SP, 01311-936, Brasil",
    city: "São Paulo",
    state: "SP",
    postalCode: "01311936",
    country: "BR"
  }
};